import { makeStyles } from '@material-ui/core/styles';
import { InfoCard, SupportButton } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { AboutContent } from '@backstage/plugin-catalog';
import React from 'react';

const useStyles = makeStyles({
  linkContainer: {
    // No divider here — only the InfoCard header line above is kept.
    marginTop: '-12px',
    color: '#000000',
    '& a': {
      color: 'inherit !important',
    },
    '& button': {
      color: '#000000 !important',
      fontWeight: 600,
    },
    '& .MuiSvgIcon-root': {
      color: '#000000 !important',
    },
  },
});

// TechDocs link intentionally disabled — only the Support button is shown.
// import DocsIcon from '@material-ui/icons/Description';
// import { HeaderIconLinkRow, IconLinkVerticalProps } from '@backstage/core-components';
//
// function createIconLink(
//   opts: Partial<IconLinkVerticalProps> & { labelKey: string },
// ): IconLinkVerticalProps {
//   return {
//     label: opts.labelKey,
//     disabled: opts.disabled ?? false,
//     icon: opts.icon ?? null,
//     href: opts.href ?? '#',
//   };
// }
//
// function useTechDocsLink(): IconLinkVerticalProps {
//   const { entity } = useEntity();
//   const openApiSpecificationUrl = (entity.metadata.annotations as { 'backstage.io/openApiSpecificationUrl'?: string })?.['backstage.io/openApiSpecificationUrl'];
//
//   // For API entities with OpenAPI spec, link to Definition tab
//   const href = openApiSpecificationUrl
//     ? 'swaggerView'
//     : 'https://github.com/cat-digital-platform/P-Apigee-APIResources/tree/master/APISpecifications';
//
//   return createIconLink(
//     {
//       labelKey: 'TechDocs',
//       disabled: false,
//       icon: <DocsIcon />,
//       href: href,
//     });
// }


function AboutSubheader() {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', paddingTop: '0px', paddingBottom: '0px' }}>
      {/* <HeaderIconLinkRow links={[useTechDocsLink()]} /> */}
      <SupportButton  title='Support' items={[{ title: 'Contact Support', links: [{ title: 'Email Cosmos Team', url: 'mailto:teamheliosservicecatalogGroup@cat.com' }] }]} />
    </div>
  );
}


export function InternalAboutCard({ iconLinks }: { iconLinks?: JSX.Element }) {
  const classes = useStyles();
  const { entity } = useEntity();
  return (
 <InfoCard variant="gridItem" title={'About'}>      
      <div className={classes.linkContainer}>
        {iconLinks ?? <AboutSubheader />}
      </div>
      <div  className='entity-about-card-content'>

      <AboutContent entity={entity} />
      </div>
 </InfoCard> );
}

export function CustomEntityAboutCard() {
  return <InternalAboutCard />;
}